import { BillingPlanEnum } from '@enum/billing-plan.enum';
import { BillingTypeEnum } from '@enum/billing-type.enum';
import { SubscriptionInterface } from '@interface/billing/billing.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialBillingState: BaseStoreInterface<SubscriptionInterface> = {
  ...BaseStoreStructure,
  data: {
    cancelAt: null,
    periodEnd: null,
    periodStart: null,
    state: 'active',
    plans: [],
    plan: {
      id: '',
      name: 'Free',
      key: '',
      platform: BillingPlanEnum.Virtual,
      type: BillingTypeEnum.Monthly,
      limits: {
        unifiedApis: 1,
        applications: 1,
        integrations: 1,
        consumers: 1,
        apiCalls: 100,
        logRetention: 0,
        hasCustomFields: false,
        hasAdditionalApiCalls: false,
        hasSupport: false,
      },
      price: 0,
      description: '',
      additionalOptions: [],
      isBasePlan: true,
    },
  },
  meta: {},
};
